// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__3hSwy","title":"styles_title__1YT-D","children":"styles_children__2Q6qe"};